$(document).ready(function () {
    //корзина добавить удалить товар cart price itemscount
    (function () {
        var callApi = function ($sender) {
            var $row = $sender.parents('form');
            $.ajax({
                url: '/catalog/recountcart',
                data: $row.serialize(),
                type: 'post',
                success: function (data) {
                    var response = JSON.parse(data);
                    getCartInfo();
                    $row.parents('.cart-row').find('.itemPrice').html(response.itemPrice);
                    $('.bottom-wrapper .total_price').html(response.cartItemsPrice);
                    $('.bottom-wrapper .discount_price').html(response.totalDiscount);
                },
                fail: function (xhr) {
                    console.log(xhr.responseText);
                },
            });
        };
        $('.minus').click(function () {
            var $input = $(this).parent().find('input');
            var count = parseInt($input.val()) - 1;
            count = count < 1 ? 1 : count;
            $input.val(count);
            $input.change();
            return false;
        });
        $('.plus').click(function () {
            var $input = $(this).parent().find('input');
            $input.val(parseInt($input.val()) + 1);
            $input.change();
            return false;
        });

        $(".itemsCount").on('keypress', function (e) {
            if (e.ctrlKey || e.altKey || e.metaKey) return;
            var current_key = String.fromCharCode(e.keyCode);
            if (current_key == null) return;
            if (current_key < '0' || current_key > '9') {
                return false;
            }
        }).on('keyup', function (e) {
            var value = $(this).val();
            if (value <= 0) {
                $(this).val(1);
            }
            callApi($(this));
        }).change(function () {
            if (!isInt($(this).val())) {
                $(this).val(1);
            }
            callApi($(this));
        });
    })();
    //удалить товар из корзины
    $('.js-cart-delete').click(function (e) {
        e.preventDefault();
        var $row = $(this).parents('.cart-row');
        var $tbody = $row.parent();
        $.ajax({
            url: '/catalog/removefromcart',
            data: $row.find('form').serialize(),
            type: 'post',
            success: function (data) {
                //console.log(data);
                var response = JSON.parse(data);
                var alsoDelete = response.with;
                getCartInfo();
                $('.bottom-wrapper .total_price').html(response.cartItemsPrice);
                $('.bottom-wrapper .discount_price').html(response.totalDiscount);
                $row.fadeOut(300, function () {
                    $(this).remove();
                    alsoDelete.forEach(function (item, i, arr) {
                        $('#cart_' + item).remove();
                    });
                    if ($tbody.find('.cart-row').length < 1) {
                        $tbody.append('<div class="cart-empty" style="display: none;">Ваша корзина пуста</div>');
                        $tbody.find('.cart-empty').fadeIn(100);
                        $('.bottom-wrapper .continue-btn').remove();
                    }
                });
            },
            fail: function (xhr) {
                console.log(xhr.responseText);
            },
        });
    });
});